import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider';

/**
 * Component that handles navigation after authentication state changes
 * Particularly useful for redirecting users after logout
 */
export function AuthNavigationHandler() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const previousUserRef = useRef(user);
  
  useEffect(() => {
    // Wait for initial auth loading to complete
    if (loading) return;
    
    const previousUser = previousUserRef.current;
    const currentUser = user;
    
    // Detect logout: user went from authenticated to not authenticated
    const hasLoggedOut = previousUser && !currentUser;
    
    if (hasLoggedOut) {
      console.log('AuthNavigationHandler: User logged out, redirecting to home');
      
      // Only redirect if user is currently on a protected route (dashboard, etc.)
      const isOnProtectedRoute = location.pathname.startsWith('/dashboard') || 
                                 location.pathname === '/';
      
      if (isOnProtectedRoute) {
        navigate('/', { replace: true });
      }
    }
    
    // Update the ref to track the current user for next render
    previousUserRef.current = currentUser;
  }, [user, loading, navigate, location.pathname]);
  
  // This component doesn't render anything
  return null;
}
